export enum StoryblokContentType {
    Richtext = 'richtext',
}
